import { useCallback, useMemo, useState } from 'react';
export const useConfirmModal = ({
  onConfirm,
  onReject
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const openConfirmModal = useCallback(() => setIsOpen(true), []);
  const handleConfirm = useCallback(() => {
    setIsOpen(false);
    onConfirm();
  }, [onConfirm]);
  const handleReject = useCallback(() => {
    setIsOpen(false);
    onReject === null || onReject === void 0 || onReject();
  }, [onReject]);
  const confirmModalProps = useMemo(() => ({
    onConfirm: handleConfirm,
    onReject: handleReject
  }), [handleConfirm, handleReject]);
  return {
    isOpen,
    openConfirmModal,
    confirmModalProps
  };
};